/* eslint-disable camelcase */
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef, useState } from 'react';
import { useOutside } from '@hn-front/utils';
import { isInViewport } from '../utils/document';
var useStuckStudents = function (_a) {
    var stuckStudents = _a.stuckStudents, stuckStudentsPopupSeen = _a.stuckStudentsPopupSeen;
    var _b = useState(false), showStuckPopup = _b[0], toggleStuckPopup = _b[1];
    var showStuckStudents = stuckStudents.length > 0;
    var refStuckContainer = useRef(null);
    var refStuckPopup = useRef(null);
    useEffect(function () {
        if (showStuckStudents && !stuckStudentsPopupSeen) {
            toggleStuckPopup(true);
        }
    }, [showStuckStudents, stuckStudentsPopupSeen]);
    useEffect(function () {
        if (showStuckPopup) {
            disableBodyScroll(document.body, { reserveScrollBarGap: true });
            if (refStuckContainer.current &&
                !isInViewport(refStuckContainer.current)) {
                refStuckContainer.current.scrollIntoView();
            }
        }
        else {
            clearAllBodyScrollLocks();
        }
        return function () { return clearAllBodyScrollLocks(); };
    }, [showStuckPopup]);
    useOutside([refStuckContainer, refStuckPopup], function () {
        toggleStuckPopup(false);
    });
    return {
        showStuckStudents: showStuckStudents,
        showStuckPopup: showStuckPopup,
        toggleStuckPopup: toggleStuckPopup,
        refStuckContainer: refStuckContainer,
        refStuckPopup: refStuckPopup,
    };
};
export { useStuckStudents };
